<template>
  <img v-if="asImg"
       :style="style"
       :src="content"
       :class="['v-img', name]"
       v-on="$listeners">
  <div
    v-else
    :style="style"
    :class="{ 'v-svg': true, 'use-parent-color': useParentColor, 'v-svg-active': active, [name]: true }"
    v-on="$listeners"
    v-html="content" />
</template>

<script>
export default {
  name: 'VSvg',

  props: {
    h: {
      default: '1em',
      type: String
    },

    active: {
      default: false,
      type: Boolean
    },

    asImg: {
      default: false,
      type: Boolean
    },

    useParentColor: {
      default: false,
      type: Boolean
    }
  },

  data() {
    return {
      content: null
    }
  },

  computed: {
    style() {
      return {
        height: this.h
      }
    },
    name() {
      return this.$slots.default[0].text.trim()
    }
  },

  created() {
    if (!this.asImg) {
      this.content = require(`!svg-inline-loader?classPrefix=true&idPrefix=true!@/assets/svg/${this.name}.svg`)
    } else {
      this.content = require(`@/assets/svg/${this.name}.svg`)
    }
  }
}
</script>

<style lang="scss">
.v-svg,
.v-img {
  display: inline-flex;
  justify-content: center;
  vertical-align: middle;
}

.v-svg {
  svg {
    height: 100%;
  }
}
</style>
